import FVector from '@data/geometry/FVector';
import { SensorData } from 'Simulations/SensorPoint';
import { StageContext } from '../../Context';
import { StageParameters, TransformStage } from '../../Stage';

export enum AveragesType {
    AVERAGE = 0,
    MEDIAN = 1,
}

export type AveragesStageParams = StageParameters & {
    averagesType: AveragesType;
    tolerance: number;
};
class AveragesStage extends TransformStage<AveragesStageParams> {
    constructor(params: AveragesStageParams) {
        super(params);
    }

    protected override processAll(context: StageContext): StageContext {
        const vector = this.compute(context.sensors);
        const outputSensors = context.sensors.map((sensorData) => {
            sensorData.setVectorialValue(vector);
            sensorData.setScalarValue(vector.mag());
            return sensorData;
        });
        this.process(outputSensors[0], context);
        return { ...context, sensors: outputSensors };
    }

    protected process(sensorData: SensorData, _context: StageContext): SensorData {
        return sensorData;
    }

    private compute(sensors: SensorData[]): FVector {
        switch (this.getParams().averagesType) {
            case AveragesType.AVERAGE:
                return this.computeAverage(sensors);
            case AveragesType.MEDIAN:
                return this.computeMedian(sensors);
        }
    }

    private computeAverage(sensors: SensorData[]): FVector {
        let sum = new FVector(0, 0, 0);
        for (const sensor of sensors) {
            sum = sum.add(sensor.getVectorialResult());
        }
        return sum.div(sensors.length);
    }

    private computeMedian(sensors: SensorData[]): FVector {
        if (sensors.length === 0) {
            return new FVector(0, 0, 0);
        }
        const sortedSensors = sensors.sort((a, b) => a.getVectorialResult().mag() - b.getVectorialResult().mag());

        const medianDir = sortedSensors[Math.floor(sortedSensors.length / 2)].getVectorialResult();

        return medianDir;
    }
}

export default AveragesStage;
